import type {ComponentType, FC} from 'react'
import {useSelector} from 'react-redux'
import {Redirect} from 'react-router-dom'
import type {RouteComponentProps} from 'react-router-dom'

import {TENANT_NO_STORAGE_RESIDENCY_REGION} from 'definitions/tenantConfig'
import {isProductivityDisabledForPrimaryDomain} from 'definitions/constant/analyticsProductivityTenantGate'
import {selectUser} from 'features/User'
import {useTenantConfigQuery} from 'hooks/useTenantConfigQuery'
import {AnalyticsRoutesEnum} from 'interfaces'

/**
 * Productivity route: redirect when tenant is no-storage or customer-disabled for Productivity.
 */
export function withAnalyticsProductivityRouteGuard<
  P extends RouteComponentProps,
>(Wrapped: ComponentType<P>): FC<P> {
  const Guarded: FC<P> = props => {
    const tenantConfigQuery = useTenantConfigQuery()
    const {primaryDomain} = useSelector(selectUser)
    const isNoStorageTenantResidency =
      tenantConfigQuery.isSuccess &&
      tenantConfigQuery.data?.data?.residencyRegion ===
        TENANT_NO_STORAGE_RESIDENCY_REGION
    if (
      isNoStorageTenantResidency ||
      isProductivityDisabledForPrimaryDomain(primaryDomain)
    ) {
      return <Redirect to={AnalyticsRoutesEnum.ANALYTICS_OVERVIEW} />
    }
    return <Wrapped {...props} />
  }
  const wrappedName = Wrapped.displayName ?? Wrapped.name ?? 'Component'
  Guarded.displayName = `withAnalyticsProductivityRouteGuard(${wrappedName})`
  return Guarded
}
